// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { define } from '@nvidia-elements/core/internal';
import { Tooltip } from '@nvidia-elements/core/tooltip';

define(Tooltip);

declare global {
  interface HTMLElementTagNameMap {
    'nve-tooltip': Tooltip;
  }
}
